import React from "react";
import apiUrl from "../../apiUrlConstant";
import { Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { JsonToExcel } from "react-json-to-excel";
import { exceldataFormate } from "../../utils/utils";
import { Loader } from 'rsuite';  
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class RentalYearWiseSummary extends React.Component {
  state = {
    leasingInventory: {},
    xAxis: [],
    barThicknesS: 10,
    chartOtions: {},
    chartData: {
      labels: [],
      datasets: [],
    },
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const superClass = this;
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: true,
          grid: {
            display: false,
          },
          ticks: {
            autoSkip: false,
            color: "black",
            font: {
              size: 10,
            },
          },
        },
        y: {
          stacked: true,
          grid: {
            display: true,
            drawBorder: true,
          },
          title: {
            display: true,
            text: "Rent",
          },
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "rgb(0, 0, 0)",
            boxWidth: 6,
            boxHeight: 6,
            usePointStyle: true,
          },
        },
        title: {
          display: false,
        },
        tooltip: {
          enabled: true,
          y: "bottom",
          backgroundColor: "#000",
        },
      },
    };
    fetch(
      `${apiUrl.apiUrl.url}/dashboard/rental-type-wise?search=` +
        this.props.searchTerm +
        `&assetVal=${this.props.assetVal}&leaseStatus=${this.props.leaseStatus}&occupierVal=${this.props.occupierVal}`,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        this.setState({ leasingInventory: data });
        var convertedData = exceldataFormate(data);
        const data1 = {
          labels: data.x,
          datasets: [
            {
              label: data.legend.y1,
              data: data.datapoints.y1,
              backgroundColor: data.bgcolor.y1,
              borderWidth: 0,
              barThickness: this.state.barThicknesS,
              borderRadius: 10,
              stack: "Stack 0",
            },
            {
              label: data.legend.y3,
              data: data.datapoints.y3,
              backgroundColor: data.bgcolor.y3,
              borderWidth: 0,
              barThickness: this.state.barThicknesS,
              borderRadius: 10,
              stack: "Stack 0",
            },
            {
              label: data.legend.y2,
              data: data.datapoints.y2,
              backgroundColor: data.bgcolor.y2,
              borderWidth: 0,
              barThickness: this.state.barThicknesS,
              borderRadius: 10,
              stack: "Stack 0",
            },

            {
                label: data.legend.y4,
                data: data.datapoints.y4,
                backgroundColor: data.bgcolor.y4,
                borderWidth: 0,
                barThickness: this.state.barThicknesS,
                borderRadius: 10,
                stack: "Stack 0",
            },
            {
                label: data.legend.y5,
                data: data.datapoints.y5,
                backgroundColor: data.bgcolor.y5,
                borderWidth: 0,
                barThickness: this.state.barThicknesS,
                borderRadius: 10,
                stack: "Stack 0",
            },
            {
                label: data.legend.y6,
                data: data.datapoints.y6,
                backgroundColor: data.bgcolor.y6,
                borderWidth: 0,
                barThickness: this.state.barThicknesS,
                borderRadius: 10,
                stack: "Stack 0",
            },

            {
                label: data.legend.y7,
                data: data.datapoints.y7,
                backgroundColor: data.bgcolor.y7,
                borderWidth: 0,
                barThickness: this.state.barThicknesS,
                borderRadius: 10,
                stack: "Stack 0",
            },
            {
                label: data.legend.y8,
                data: data.datapoints.y8,
                backgroundColor: data.bgcolor.y8,
                borderWidth: 0,
                barThickness: this.state.barThicknesS,
                borderRadius: 10,
                stack: "Stack 0",
            },
            {
                label: data.legend.y9,
                data: data.datapoints.y9,
                backgroundColor: data.bgcolor.y9,
                borderWidth: 0,
                barThickness: this.state.barThicknesS,
                borderRadius: 10,
                stack: "Stack 0",
            },
          ],
        };

        superClass.setState({
          chartOtions: options,
          chartData: data1,
          isLoad: true,
          convertedData: convertedData,
        });
      });
  }

  downloadPdf = () => {
    const input = document.getElementById("leasingInventory");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHight);
      pdf.save("leasingInventory.pdf");
    });
  };

  render() {
    return (
      <>
        <div className="row m-0">
          <div className="col-lg-6 p-0">
            <h4>Rental Year Wise</h4>
          </div>
          <div className="col-lg-6 p-0 position-relative float-right">
            <Dropdown style={{ float: "right" }}>
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                className="chartDownloadContainer"
              ></Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={(e) => {
                    this.downloadPdf();
                  }}
                >
                  Download as PDF
                </Dropdown.Item>
                <Dropdown.Item>
                  <JsonToExcel
                    title="Download as Excel"
                    data={this.state.convertedData}
                    fileName="RentalYearWiseSummary"
                    btnClassName="graphExcelDownloadBtn"
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="col-12 position-relative" id="leasingInventory">
          {
              (this.state.chartData.datasets.length == 0) && 
              <Loader size="lg" content="Loading... " center/>
            }
          <Bar options={this.state.chartOtions} data={this.state.chartData} />
        </div>
      </>
    );
  }
}
export default withRouter(RentalYearWiseSummary);
